import {Link} from 'react-router-dom';

function UnderConstruction() {
  return (
    <div className="bg-[#f8fafc] flex flex-col items-center text-xl min-h-screen text-center pt-[50%] md:pt-[10%] mx-5">
        <h1 className="text-8xl md:text-9xl font-extrabold text-center bg_Gradient bg-clip-text text-transparent mb-3" >
            oops
        </h1>
        <p className="text-3xl md:text-4xl font-bold mb-10">Page Under Construction</p>
        <p className="text-[#65738a] text-base md:text-lg font-semibold mb-10"> This page is being built.<br />Check back soon!</p>

        <Link to="/">
          <button
            type="submit"
            className='bg-[#6949fa] h-10 rounded-md py-3 px-5 md:px-10 text-base font-bold text-white border border-[#6949fa] flex items-center justify-center hover:cursor-pointer hover:shadow-xl transition duration-[.5s] ease-in-out'>
                BACK TO HOMEPAGE
          </button>
        </Link>
        
    </div>
  );
}

export default UnderConstruction;
